import * as classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import { AssetPreview, ContentTypeIcon, EditableLabel } from 'signoxe/components';
import { Icon } from 'signoxe/components/widgets';
import { AssetPropType } from 'signoxe/constants/propTypes';
import { isAssetEditable } from 'signoxe/utils/assets';
import './styles.scss';

import Dropdown from 'rc-dropdown';
import Menu, {MenuItem} from 'rc-menu';
import 'rc-dropdown/assets/index.css';



const AssetTableRow = ({asset, editable, selected, onChange, onClick, onClickDelete}) => {

  const moveItem = () => {
    console.log(asset)
  }
  
  const menu = (
    <Menu style={{padding: '5px' }}>
      <MenuItem onClick={moveItem} key="1">Folder 1</MenuItem>
      <MenuItem key="2">Folder 2</MenuItem>
    </Menu>
  );

return(
  <Dropdown
        trigger={['contextMenu']}
        overlay={menu}
        animation="slide-up"
        alignPoint
      >
  <tr className={classnames('depth-1', {selected})}>
    <td onClick={() => onClick && onClick(asset)}>
      <ContentTypeIcon size="2rem" type={asset.type}/>
    </td>
    <td>
      <AssetPreview asset={asset} size="6rem" onClick={() => onClick && onClick(asset)}/>
    </td>
    <td className="name">
      <EditableLabel value={asset.name}
                     enabled={editable && !!onChange}
                     onChange={(newValue) => onChange({...asset, name: newValue})}/></td>
    <td>{editable && onClickDelete &&
    <Icon title="Delete"
          name="trash-o"
          size="2rem"
          color="black"
          onClick={() => onClickDelete(asset)}/>}</td>
  </tr>
  </Dropdown>
)}

AssetTableRow.propTypes = {
  asset: AssetPropType.isRequired,
  selected: PropTypes.bool.isRequired,
  editable: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onClickDelete: PropTypes.func,
};

const AssetTableView = ({assets, selection, onAssetChange, onAssetDelete, onAssetClick}) => (
  <table className="asset-table-view">
    <thead>
    <tr>
      <th>Type</th>
      <th>Thumbnail</th>
      <th>Name</th>
      <th>Delete</th>
    </tr>
    </thead>
    <tbody>
    {assets.map(asset => (
      <AssetTableRow key={asset.id}
                     asset={asset}
                     editable={isAssetEditable(asset)}
                     selected={selection && !!selection[asset.id]}
                     onChange={onAssetChange}
                     onClick={onAssetClick}
                     onClickDelete={onAssetDelete}/>
    ))}
    </tbody>
  </table>
);

AssetTableView.propTypes = {
  assets: PropTypes.arrayOf(AssetPropType),
  selection: PropTypes.object,
  onAssetChange: PropTypes.func,
  onAssetClick: PropTypes.func,
  onAssetDelete: PropTypes.func,
};

export default AssetTableView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetTableView/index.js